export default __webpack_public_path__ + "static/media/right-angle.a1507639.svg";